(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-section"] && !Shopify.designMode) return;
  try {
    
  // Format price from cents to money format
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }

  // Pack selection functionality
  document.addEventListener('DOMContentLoaded', function () {
    const packOptions = document.querySelectorAll('.pack-option');
    const priceAmount = document.querySelector('[data-price-amount]');
    const totalPrice = document.querySelector('[data-total-price]');
    const originalPrice = document.querySelector('[data-original-price]');
    const buttonPrice = document.querySelector('[data-button-price]');
    const discountBadge = document.querySelector('[data-discount-badge]');
    const discountPercentage = document.querySelector('[data-discount-percentage]');
    const discountOff = document.querySelector('[data-discount-off]');
    const purchaseOptions = document.querySelectorAll('[data-purchase-option]');
    const subscribeContainer = document.querySelector('[data-subscribe-container]');
    const subscribeButton = document.querySelector('[data-action="add-to-cart"]');
    const oneTimeButton = document.querySelector('[data-action="add-to-cart-one-time"]');
    const oneTimePurchasePrice = document.querySelector('[data-one-time-purchase-price]');
    const productImage = document.querySelector('[data-product-image]');
    
    // Delivery dropdown functionality - declare early so populateDeliveryOptions can use them
    const deliveryButton = document.querySelector('[data-delivery-button]');
    const deliveryDropdown = document.querySelector('[data-delivery-dropdown]');
    const deliveryOptionsList = document.querySelector('[data-delivery-options-list]');
    const deliveryButtonText = document.querySelector('[data-delivery-button-text]');

    packOptions.forEach((option) => {
      option.addEventListener('click', function () {
        // Remove active class from all options
        packOptions.forEach((opt) => {
          opt.classList.remove('pack-option--active');
          opt.setAttribute('aria-pressed', 'false');
        });

        // Add active class to clicked option
        this.classList.add('pack-option--active');
        this.setAttribute('aria-pressed', 'true');

        // Update pricing based on button data attributes
        updatePricing(this);

        // Show/hide free gifts container based on selected pack
        const freeGiftsContainer = document.querySelector('[data-free-gifts-container]');
        const selectedPack = this.dataset.pack;
        if (freeGiftsContainer) {
          if (selectedPack === '1') {
            freeGiftsContainer.style.display = 'none';
          } else {
            freeGiftsContainer.style.display = '';
          }
        }

        // Repopulate delivery dropdown with this product's frequencies
        populateDeliveryOptions();
      });
    });

    function updatePricing(button) {
      // Get price data from button attributes
      const pricePerEach = parseInt(button.dataset.pricePerEach) || 0;
      const subscriptionPrice = parseInt(button.dataset.subscriptionPrice) || 0;
      const compareAtPrice = parseInt(button.dataset.compareAtPrice) || 0;
      const discountType = button.dataset.discountType || 'none';
      const discountValue = parseFloat(button.dataset.discountValue) || 0;

      // Update "each" price (price per each)
      if (priceAmount && pricePerEach > 0) {
        priceAmount.textContent = formatMoney(pricePerEach);
      }

      // Update total subscription price
      if (totalPrice && subscriptionPrice > 0) {
        totalPrice.textContent = formatMoney(subscriptionPrice);
      }

      // Update original/compare-at price
      // Only show if compareAtPrice is greater than original price and greater than 0
      const originalPriceValue = parseInt(button.dataset.price) || 0;
      if (originalPrice) {
        if (compareAtPrice > originalPriceValue && compareAtPrice > 0) {
          originalPrice.textContent = formatMoney(compareAtPrice);
          originalPrice.style.display = '';
        } else {
          originalPrice.style.display = 'none';
        }
      }

      // Update add to cart button price (subscription)
      if (buttonPrice && subscriptionPrice > 0) {
        buttonPrice.textContent = formatMoney(subscriptionPrice);
      }

      // Update one-time purchase option price display (in the button)
      if (oneTimePurchasePrice && originalPriceValue > 0) {
        oneTimePurchasePrice.textContent = formatMoney(originalPriceValue);
      }

      // Update discount percentage badge
      if (discountBadge && discountPercentage && discountOff) {
        if (discountType === 'percentage' && discountValue > 0) {
          discountPercentage.textContent = Math.round(discountValue) + '%';
          discountOff.style.display = '';
          discountBadge.style.display = '';
        } else {
          discountPercentage.textContent = '';
          discountOff.style.display = 'none';
          discountBadge.style.display = 'none';
        }
      }

      // Update delivery button text with frequency
      const deliveryButtonText = document.querySelector('[data-delivery-button-text]');
      const frequency = button.dataset.frequency || '';
      if (deliveryButtonText && frequency) {
        deliveryButtonText.textContent = frequency;
      }

      if (productImage) {
        const fallbackImage = productImage.dataset.fallbackImage;
        const defaultImage = productImage.dataset.defaultImage;
        const defaultAlt = productImage.dataset.defaultAlt || '';
        const fallbackAlt = productImage.dataset.fallbackAlt || '';
        const newImage = button.dataset.image || defaultImage || fallbackImage;
        const newAlt = button.dataset.imageAlt || defaultAlt || fallbackAlt || '';

        if (newImage) {
          productImage.src = newImage;
        }
        productImage.alt = newAlt;
      }
    }

    function setDefaultPackOption() {
      if (!packOptions.length) return;
      
      // Check if there's already an active button (set by Liquid template)
      let defaultButton = Array.from(packOptions).find(opt => opt.classList.contains('pack-option--active'));
      
      // If no active button, prefer the 3-pack (middle option), otherwise use the first one
      if (!defaultButton) {
        // Try to find 3-pack first
        defaultButton = Array.from(packOptions).find(opt => opt.dataset.pack === '3');
        // If no 3-pack, use the middle option, or first one as fallback
        if (!defaultButton) {
          const middleIndex = Math.floor(packOptions.length / 2);
          defaultButton = packOptions[middleIndex] || packOptions[0];
        }
        packOptions.forEach((opt) => {
          opt.classList.remove('pack-option--active');
          opt.setAttribute('aria-pressed', 'false');
        });
        defaultButton.classList.add('pack-option--active');
        defaultButton.setAttribute('aria-pressed', 'true');
      }
      
      if (defaultButton) {
        // Update pricing based on button's initial data attributes
        updatePricing(defaultButton);
        
        // Show/hide free gifts container based on default pack
        const freeGiftsContainer = document.querySelector('[data-free-gifts-container]');
        const selectedPack = defaultButton.dataset.pack;
        if (freeGiftsContainer) {
          if (selectedPack === '1') {
            freeGiftsContainer.style.display = 'none';
          } else {
            freeGiftsContainer.style.display = '';
          }
        }
        
        // Populate delivery dropdown with default product's frequencies
        // This will auto-select the first plan if there's only one
        populateDeliveryOptions();
      }
    }

    setDefaultPackOption();

    // Purchase option toggling
    function setPurchaseOption(type) {
      if (!purchaseOptions.length) return;

      purchaseOptions.forEach((option) => {
        const isActive = option.dataset.purchaseOption === type;
        option.classList.toggle('purchase-option--active', isActive);
        option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (subscribeButton) {
        subscribeButton.style.display = type === 'subscribe' ? 'inline-flex' : 'none';
      }
    }

    if (purchaseOptions.length > 0) {
      purchaseOptions.forEach((option) => {
        // Skip one-time button - it has its own add-to-cart handler
        if (option.dataset.action === 'add-to-cart-one-time') {
          return;
        }

        option.addEventListener('click', function () {
          const type = this.dataset.purchaseOption;
          if (type) {
            setPurchaseOption(type);
          }
        });

        option.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const type = this.dataset.purchaseOption;
            if (type) {
              setPurchaseOption(type);
            }
          }
        });
      });

      setPurchaseOption('subscribe');
    }

    // Populate delivery options from active pack button's selling plans
    function populateDeliveryOptions() {
      if (!deliveryOptionsList) {
        return;
      }

      // Get the currently active pack button
      const activeButton = document.querySelector('.pack-option--active');
      if (!activeButton) {
        return;
      }

      // Get selling plans data from active button
      // Try both camelCase and direct attribute access
      let sellingPlansJson = activeButton.dataset.sellingPlans || activeButton.getAttribute('data-selling-plans');
      if (!sellingPlansJson) {
        return;
      }

      // Decode HTML entities if present
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sellingPlansJson;
      sellingPlansJson = tempDiv.textContent || tempDiv.innerText || sellingPlansJson;

      let sellingPlans = [];
      try {
        sellingPlans = JSON.parse(sellingPlansJson);
      } catch (e) {
        return;
      }

      if (!Array.isArray(sellingPlans) || sellingPlans.length === 0) {
        return;
      }

      // Clear existing options
      deliveryOptionsList.innerHTML = '';

      // Show/hide dropdown arrow and enable/disable expansion based on number of options
      const hasMultipleOptions = sellingPlans.length > 1;
      if (deliveryButton) {
        const arrowIcon = deliveryButton.querySelector('svg');
        if (arrowIcon) {
          arrowIcon.style.display = hasMultipleOptions ? '' : 'none';
        }
        deliveryButton.style.cursor = hasMultipleOptions ? 'pointer' : 'default';
        deliveryButton.setAttribute('data-has-multiple-options', hasMultipleOptions);
      }

      // Helper function to update active button with plan data
      function updateActiveButtonWithPlan(plan) {
        activeButton.setAttribute('data-variant-id', plan.variant_id);
        activeButton.setAttribute('data-selling-plan-id', plan.selling_plan_id);
        activeButton.setAttribute('data-frequency', plan.frequency);
        activeButton.setAttribute('data-price', plan.price);
        activeButton.setAttribute('data-compare-at-price', plan.compare_at_price);
        activeButton.setAttribute('data-subscription-price', plan.subscription_price);
        activeButton.setAttribute('data-price-per-each', plan.price_per_each);
        activeButton.setAttribute('data-discount-type', plan.discount_type);
        activeButton.setAttribute('data-discount-value', plan.discount_value);
        activeButton.setAttribute('data-compare-at-discount-type', plan.compare_at_discount_type);
        activeButton.setAttribute('data-compare-at-discount-value', plan.compare_at_discount_value);
        activeButton.setAttribute('data-compare-at-discount-amount', plan.compare_at_discount_amount);
        
        // Update pricing with new data
        updatePricing(activeButton);
      }

      // If only one plan, auto-select it immediately
      if (sellingPlans.length === 1) {
        const plan = sellingPlans[0];
        
        // Update active button's data attributes with the single plan's data
        updateActiveButtonWithPlan(plan);
        
        // Update delivery button text
        if (deliveryButtonText) {
          deliveryButtonText.textContent = plan.frequency;
        }
        
        // Still create the option item for display (but it won't be clickable)
        const li = document.createElement('li');
        li.className = 'delivery-option-item delivery-option-item--active';
        li.textContent = plan.frequency;
        li.setAttribute('data-frequency', plan.frequency);
        li.setAttribute('data-variant-id', plan.variant_id);
        li.setAttribute('data-selling-plan-id', plan.selling_plan_id);
        li.style.cursor = 'default';
        deliveryOptionsList.appendChild(li);
        
        // Ensure dropdown is closed
        if (deliveryDropdown) {
          deliveryDropdown.style.display = 'none';
        }
        if (deliveryButton) {
          deliveryButton.setAttribute('aria-expanded', 'false');
        }
        
        return;
      }

      // Multiple plans - create clickable options
      sellingPlans.forEach((plan, index) => {
        const li = document.createElement('li');
        li.className = 'delivery-option-item';
        li.textContent = plan.frequency;
        li.setAttribute('data-frequency', plan.frequency);
        li.setAttribute('data-variant-id', plan.variant_id);
        li.setAttribute('data-selling-plan-id', plan.selling_plan_id);
        
        // Store plan data for later use
        li.planData = plan;
        
        li.addEventListener('click', function (e) {
          e.stopPropagation();
          
          // Update the active button's data attributes with selected plan data
          updateActiveButtonWithPlan(plan);

          // Update active state in dropdown
          deliveryOptionsList.querySelectorAll('.delivery-option-item').forEach((item) => {
            item.classList.remove('delivery-option-item--active');
          });
          li.classList.add('delivery-option-item--active');

          // Update delivery button text
          if (deliveryButtonText) {
            deliveryButtonText.textContent = plan.frequency;
          }

          // Close dropdown
          if (deliveryDropdown) {
            deliveryDropdown.style.display = 'none';
          }
          if (deliveryButton) {
            deliveryButton.setAttribute('aria-expanded', 'false');
          }
        });

        deliveryOptionsList.appendChild(li);
      });

      // Set initial active state based on current button's frequency
      const activeFrequency = activeButton.dataset.frequency;
      if (activeFrequency) {
        deliveryOptionsList.querySelectorAll('.delivery-option-item').forEach((item) => {
          if (item.dataset.frequency === activeFrequency) {
            item.classList.add('delivery-option-item--active');
          }
        });
      } else if (sellingPlans.length > 0) {
        // If no active frequency is set, select the first plan
        const firstPlan = sellingPlans[0];
        updateActiveButtonWithPlan(firstPlan);
        
        const firstItem = deliveryOptionsList.querySelector('.delivery-option-item');
        if (firstItem) {
          firstItem.classList.add('delivery-option-item--active');
        }
        
        if (deliveryButtonText) {
          deliveryButtonText.textContent = firstPlan.frequency;
        }
      }
    }

    // Toggle dropdown
    if (deliveryButton && deliveryDropdown) {
      deliveryButton.addEventListener('click', function (e) {
        e.stopPropagation();
        
        // Check if there are multiple options - if not, don't allow expansion
        const hasMultipleOptions = this.getAttribute('data-has-multiple-options') === 'true';
        if (!hasMultipleOptions) {
          return; // Don't expand if only one option
        }
        
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        if (!isExpanded) {
          // Repopulate dropdown with current product's frequencies before opening
          populateDeliveryOptions();
        }
        
        this.setAttribute('aria-expanded', !isExpanded);

        if (isExpanded) {
          deliveryDropdown.style.display = 'none';
        } else {
          deliveryDropdown.style.display = 'block';
        }
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!deliveryButton.contains(e.target) && !deliveryDropdown.contains(e.target)) {
          deliveryDropdown.style.display = 'none';
          deliveryButton.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Note: Delivery dropdown repopulation is now handled in the main pack button click handler above

    // Add to cart functionality
    function addToCart(variantId, sellingPlanId = null, quantity = 1) {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      
      // Add selling plan ID if it's a subscription
      if (sellingPlanId) {
        formData.append('selling_plan', sellingPlanId);
      }

      // Get cart sections to update
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      let cartItemComponentsSectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
      });
      if (cartItemComponentsSectionIds.length > 0) {
        formData.append('sections', cartItemComponentsSectionIds.join(','));
      }

      // Add to cart - matching theme's product-form.js pattern
      return fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html', // Match theme's product-form.js
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            // Error occurred
            throw new Error(data.message || 'Failed to add item to cart');
          }
          
          // Dispatch cart:update event to trigger cart drawer and cart updates
          // Match CartAddEvent structure: event name is 'cart:update'
          const cartUpdateEvent = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'subscription-section',
              data: {
                didError: false,
                source: 'subscription-section',
                variantId: variantId.toString(),
                itemCount: data.item_count || 0,
                sections: data.sections || {},
              },
            },
          });
          document.dispatchEvent(cartUpdateEvent);
          
          // Open cart drawer - try both waiting for custom element and direct access
          const openCartDrawer = () => {
            const cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          };
          
          // Try to open immediately, or wait for custom element to be defined
          if (customElements.get('cart-drawer-component')) {
            openCartDrawer();
          } else {
            customElements.whenDefined('cart-drawer-component').then(openCartDrawer);
          }
          
          return data;
        });
    }

    // Subscribe button click handler
    if (subscribeButton) {
      subscribeButton.addEventListener('click', function (e) {
        e.preventDefault();
        
        const activeButton = document.querySelector('.pack-option--active');
        if (!activeButton) {
          alert('Please select a product pack option');
          return;
        }

        // Try both dataset and getAttribute for compatibility
        const variantId = activeButton.dataset.variantId || activeButton.getAttribute('data-variant-id');
        const sellingPlanId = activeButton.dataset.sellingPlanId || activeButton.getAttribute('data-selling-plan-id');
        
        if (!variantId) {
          alert('Error: No variant ID found. Please refresh the page and try again.');
          return;
        }

        if (!sellingPlanId) {
          alert('Please select a delivery frequency from the dropdown');
          return;
        }

        // Disable button during request
        subscribeButton.disabled = true;
        const originalText = subscribeButton.innerHTML;
        subscribeButton.innerHTML = '<span>Adding...</span>';

        addToCart(variantId, sellingPlanId, 1)
          .then(() => {
            // Success - cart drawer should open automatically via CartAddEvent
            subscribeButton.innerHTML = originalText;
            subscribeButton.disabled = false;
          })
          .catch((error) => {
            alert(error.message || 'Failed to add item to cart. Please try again.');
            subscribeButton.innerHTML = originalText;
            subscribeButton.disabled = false;
          });
      });
    }

    // One-time purchase button click handler
    if (oneTimeButton) {
      oneTimeButton.addEventListener('click', function (e) {
        e.preventDefault();
        
        const activeButton = document.querySelector('.pack-option--active');
        if (!activeButton) {
          alert('Please select a product pack option');
          return;
        }

        // Try both dataset and getAttribute for compatibility
        const variantId = activeButton.dataset.variantId || activeButton.getAttribute('data-variant-id');
        
        if (!variantId) {
          alert('Error: No variant ID found. Please refresh the page and try again.');
          return;
        }

        // Disable button during request
        oneTimeButton.disabled = true;
        const purchaseType = oneTimeButton.querySelector('.purchase-type');
        const purchasePrice = oneTimeButton.querySelector('.purchase-price');
        const originalTypeText = purchaseType ? purchaseType.textContent : '';
        const originalPriceText = purchasePrice ? purchasePrice.textContent : '';
        
        // Show loading state
        if (purchaseType) purchaseType.textContent = 'Adding...';
        if (purchasePrice) purchasePrice.style.display = 'none';

        // One-time purchase - no selling plan
        addToCart(variantId, null, 1)
          .then(() => {
            // Success - cart drawer should open automatically via CartAddEvent
            if (purchaseType) purchaseType.textContent = originalTypeText;
            if (purchasePrice) {
              purchasePrice.textContent = originalPriceText;
              purchasePrice.style.display = '';
            }
            oneTimeButton.disabled = false;
          })
          .catch((error) => {
            alert(error.message || 'Failed to add item to cart. Please try again.');
            if (purchaseType) purchaseType.textContent = originalTypeText;
            if (purchasePrice) {
              purchasePrice.textContent = originalPriceText;
              purchasePrice.style.display = '';
            }
            oneTimeButton.disabled = false;
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
